// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-item {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .product-details p {
    margin: 8px 0;
    font-size: 14px;
  }
  
  .product-details p strong {
    color: #333333;
  }
  
  .product-complements h5,
  .product-additionals h5 {
    font-size: 16px;
    color: #555555;
  }
  
  .product-complements p,
  .product-additionals p {
    margin: 4px 0;
    font-size: 14px;
  }
  
  .product-complements p strong,
  .product-additionals p strong {
    color: #333333;
  }
  

  .product-item {
    margin-bottom: 15px;
  }
  

  .customer-info {
    display: flex;
    align-items: center;
    margin-top: 12px;
  }
  
  .customer-picture {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 12px;
    object-fit: cover;
  }
  

  .address-info p strong {
    color: #333333;
  }
  
  .order-summary p strong {
    color: #333333;
  }
  
  .finalize-button {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  
  .save-button {
    padding: 8px 16px;
    background-color: #1890ff;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .save-button:disabled {
    background-color: #a0d3ff;
    cursor: not-allowed;
  }
  

  .filter-segmented {
    height: 100px;
    width: 98%;
    margin-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  @media only screen and (max-width: 600px) {
    .order-item {
      padding: 12px;
    }
  
    .customer-info {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .customer-picture {
      margin-bottom: 8px;
    }
  
    .save-button {
      width: 100%;
    }
  }

.product-info {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .product-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 12px;
  }
  
  .complement-item,
  .additional-item {
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 8px;
    margin-bottom: 10px;
    background-color: #f9f9f9;
  }
  
  .complement-item:last-child,
  .additional-item:last-child {
    margin-bottom: 0;
  }
  
  @media only screen and (max-width: 600px) {
    .product-image {
      width: 40px;
      height: 40px;
    }
  
    .product-info p {
      font-size: 14px;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/pages/OrderList/OrderList.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;;;EAGA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;EACF;;AAEF;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".order-item {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    padding: 16px;\n    margin-bottom: 20px;\n    background-color: #ffffff;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .product-details p {\n    margin: 8px 0;\n    font-size: 14px;\n  }\n  \n  .product-details p strong {\n    color: #333333;\n  }\n  \n  .product-complements h5,\n  .product-additionals h5 {\n    font-size: 16px;\n    color: #555555;\n  }\n  \n  .product-complements p,\n  .product-additionals p {\n    margin: 4px 0;\n    font-size: 14px;\n  }\n  \n  .product-complements p strong,\n  .product-additionals p strong {\n    color: #333333;\n  }\n  \n\n  .product-item {\n    margin-bottom: 15px;\n  }\n  \n\n  .customer-info {\n    display: flex;\n    align-items: center;\n    margin-top: 12px;\n  }\n  \n  .customer-picture {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    margin-right: 12px;\n    object-fit: cover;\n  }\n  \n\n  .address-info p strong {\n    color: #333333;\n  }\n  \n  .order-summary p strong {\n    color: #333333;\n  }\n  \n  .finalize-button {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n  }\n  \n  .save-button {\n    padding: 8px 16px;\n    background-color: #1890ff;\n    color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .save-button:disabled {\n    background-color: #a0d3ff;\n    cursor: not-allowed;\n  }\n  \n\n  .filter-segmented {\n    height: 100px;\n    width: 98%;\n    margin-left: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  @media only screen and (max-width: 600px) {\n    .order-item {\n      padding: 12px;\n    }\n  \n    .customer-info {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  \n    .customer-picture {\n      margin-bottom: 8px;\n    }\n  \n    .save-button {\n      width: 100%;\n    }\n  }\n\n.product-info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n  \n  .product-image {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n    object-fit: cover;\n    margin-right: 12px;\n  }\n  \n  .complement-item,\n  .additional-item {\n    border: 1px solid #f0f0f0;\n    border-radius: 6px;\n    padding: 8px;\n    margin-bottom: 10px;\n    background-color: #f9f9f9;\n  }\n  \n  .complement-item:last-child,\n  .additional-item:last-child {\n    margin-bottom: 0;\n  }\n  \n  @media only screen and (max-width: 600px) {\n    .product-image {\n      width: 40px;\n      height: 40px;\n    }\n  \n    .product-info p {\n      font-size: 14px;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
